import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

//slug
import slug from "../slug"

//styles
import * as Styled from "./page-changer.styles"

const query = graphql`
  {
    tagespflegeIcon: file(relativePath: { regex: "/tagespflegeIcon.png$/" }) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
    ambulantePflegeIcon: file(
      relativePath: { regex: "/ambulantePflegeIcon.png$/" }
    ) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
    wohnheimIcon: file(relativePath: { regex: "/wohnheimIcon.png$/" }) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
  }
`

const PageChanger = ({ location }) => {
  const data = useStaticQuery(query)
  const tagespflegeIcon = getImage(data.tagespflegeIcon)
  const ambulantePflegeIcon = getImage(data.ambulantePflegeIcon)
  const wohnheimIcon = getImage(data.wohnheimIcon)

  return (
    <Styled.Container aria-label="Sekundär Navigation">
      {location.pathname === slug[0] ? null : (
        <Link to={slug[0]}>
          <Styled.ImgContainer>
            <GatsbyImage image={wohnheimIcon} alt="" />
          </Styled.ImgContainer>
          <span>WG</span>
        </Link>
      )}
      {location.pathname === slug[1] ? null : (
        <Link to={slug[1]}>
          <Styled.ImgContainer>
            <GatsbyImage image={tagespflegeIcon} alt="" />
          </Styled.ImgContainer>
          <span>Tagesstätte</span>
        </Link>
      )}
      {location.pathname === slug[2] ? null : (
        <Link to={slug[2]}>
          <Styled.ImgContainer>
            <GatsbyImage image={ambulantePflegeIcon} alt="" />
          </Styled.ImgContainer>
          <span>Ambulante Pflege</span>
        </Link>
      )}
    </Styled.Container>
  )
}
export default PageChanger
